import {
  FooterVariant,
  InlineNotification,
  InlineNotificationVariant,
  SvgIcon,
} from "@skylead/component-library"
import React from "react"

import { ModalVariant } from "../components/atoms/Modal"
import TwoFactor from "../components/atoms/TwoFactor"
import {
  closeModal,
  deactivateTwoFactor,
  generateTwoFactorSecretUri,
  showModal,
} from "../redux/actions"
import { store } from "../redux/store"

const disable2FAModal = tt => {
  store.dispatch(
    showModal(
      ModalVariant.SMALL,
      tt("2FA-setup"),
      <div className="setup-successfully">
        <SvgIcon
          icon="setup-successfully-two-factor"
          className="setup-successfully__two-factor-icon"
          spanClassName="setup-successfully__span"
        />
        <InlineNotification
          type={InlineNotificationVariant.SUCCESS}
          label={tt("account.settings.set-to-fa.notification.label")}
        />
      </div>,
      FooterVariant.TRANSACTIONAL_DESTRUCTIVE,
      {
        label: tt("disable-2FA-authentication"),
        onClick: () => store.dispatch(deactivateTwoFactor(tt)),
      },
      { label: tt("close") },
    ),
  )
}

const twoFactorConfigurationModal = tt => {
  store.dispatch(showModal(ModalVariant.LARGE, tt("setup-2fa"), <TwoFactor />))
}

const setUp2FAModal = async tt => {
  await store.dispatch(generateTwoFactorSecretUri())
  store.dispatch(
    showModal(
      ModalVariant.SMALL,
      tt("setup-2fa"),
      <div className="setup-2fa">
        <SvgIcon
          icon="setup-two-factor"
          className="setup-2fa__icon"
          spanClassName="setup-2fa__span"
        />
        <p className="setup-2fa__text">
          {tt("setup-2fa-model.verify-email-success.msg")} <i>{tt("account-settings")}</i>.
        </p>
      </div>,
      FooterVariant.TRANSACTIONAL,
      { label: tt("setup-2fa"), onClick: twoFactorConfigurationModal(tt) },
      { label: tt("setup-2fa-model.do-it-later"), onClick: () => store.dispatch(closeModal()) },
      undefined,
      true,
    ),
  )
}

export { disable2FAModal, setUp2FAModal, twoFactorConfigurationModal }
